import PropTypes from 'prop-types';
import React from 'react';

import { MEMBER_SHAPE, COMPANY_SHAPE } from '../../../../config/prop-types';

/**
 * Displays campaign finance information for featured lawmaker or company
 */
export default class FeatureCard extends React.PureComponent {
  /**
   * @returns {object} - JSX for the component.
   */
  render() {
    const {
      entity,
      handleEntityClick,
      imageUrl,
      tileDesc,
      title,
      type,
    } = this.props;
    if (! entity) {
      // Render a card when a company or congressperson isn't defined.
      return (
        <div className="feature-card">
          <div className="feature-card--title">{title}</div>
          <div className="feature-card--contents">
            <img
              className="feature-card--image"
              src={imageUrl}
              alt=""
              aria-hidden="true"
            />
            <div className="feature-card--unknown">
              <div className="feature-card--lgName">?</div>
            </div>
            <div className="feature-card--description">{tileDesc}</div>
          </div>
        </div>
      );
    }
    return (
      <div className="feature-card">
        <div className="feature-card--title">{title}</div>
        <div className="feature-card--contents">
          <img
            className="feature-card--image"
            src={imageUrl}
            alt=""
            aria-hidden="true"
          />
          {'MEMBER' === type ? (
            <div>
              <div className="feature-card--smName">
                {('House' === entity.chamber) ? 'Rep. ' : 'Sen. '}
                {entity.firstName}
              </div>
              <div className="feature-card--lgName">{entity.lastName}</div>
            </div>
          ) : (
            <div>
              <div className="feature-card--smName">{entity.parent}</div>
              <div className="feature-card--lgName">{entity.name}</div>
            </div>
          )}
          {'MEMBER' === type ? (
            <div className="feature-card--office">
              {entity.party}
              -
              {entity.state}
            </div>
          ) : (
            <div className="feature-card--office">
              {entity.headquarters}
            </div>
          )}
          <div className="feature-card--description">{tileDesc}</div>
        </div>
        <div className="link-button">
          <button
            href=""
            className="btn btn-primary"
            onClick={(e) => handleEntityClick(e, entity.id)}
          >
            Show details
          </button>
        </div>
      </div>
    );
  }
}

FeatureCard.defaultProps = {
  entity: undefined,
};

FeatureCard.propTypes = {
  entity: PropTypes.oneOfType([
    PropTypes.shape(MEMBER_SHAPE),
    PropTypes.shape(COMPANY_SHAPE),
  ]),
  imageUrl: PropTypes.string.isRequired,
  handleEntityClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  tileDesc: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
